module.exports = __webpack_public_path__ + "static/img/br_stomach_ok.c4e92e2d.webp";